import { BROWSIES_GUIDE_ID, RECENTS_GUIDE_ID } from '../constants/categories';
import {
  CLEAR_ALL_RECENTS_SUCCESS_TOAST,
  CLEAR_SINGLE_RECENT_SUCCESS_TOAST,
} from '../constants/localizations/settings';
import { selectRouteProps } from '../selectors/app';
import getStoreGuideId from '../utils/guideItem/getStoreGuideId';
import { types } from '../utils/guideItemTypes';
import parseSort from '../utils/queryString/parseSort';
import { showMessage } from './messagePopover';

export const FETCH_CATEGORY = 'FETCH_CATEGORY';
export const CLEAR_CATEGORY = 'CLEAR_CATEGORY';
export const CLEAR_ALL_RECENTS = 'CLEAR_ALL_RECENTS';
export const REMOVE_RECENT = 'REMOVE_RECENT';
export const SET_BRAZE_CATEGORY_CARDS = 'SET_BRAZE_CATEGORY_CARDS';

export function fetchCategoryEffect(storeGuideId, { guideId, attributes, itemToken = '' }) {
  return (dispatch) => {
    const params = {
      ...parseSort(attributes),
      itemToken,
    };

    return dispatch({
      type: FETCH_CATEGORY,
      api: {
        endpoint: ['ui', 'get'],
        args: [{ guideId, params }],
      },
      meta: {
        contentId: storeGuideId,
      },
    });
  };
}

export function fetchCategoryWithContextEffect(type, guideId, contextGuideId, meta = {}) {
  return (dispatch) => {
    return dispatch({
      type,
      api: {
        endpoint: ['ui', 'get'],
        args: [{ guideId, contextGuideId }],
      },
      meta: {
        contentId: guideId,
        ...meta,
      },
    });
  };
}

export function customBrowseItemsTransform(resp, guideId) {
  const children = resp?.data?.items?.[0]?.children || [];
  return {
    guideId,
    type: types.container,
    children,
  };
}

// this is different from the regular browse items call
// to be used for categories which return landing carousel type response
export function getCustomBrowseItemsByGuideId(guideId, type) {
  const transform = (resp) => customBrowseItemsTransform(resp, guideId);

  return {
    type,
    api: {
      endpoint: ['ui', 'get'],
      args: [{ guideId }],
      transform,
    },
    meta: {
      contentId: guideId,
    },
  };
}

export function fetchCategory(guideContext) {
  const storeGuideId = getStoreGuideId(guideContext.guideId, guideContext.attributes);
  return fetchCategoryEffect(storeGuideId, guideContext);
}

export function clearCategory(guideId) {
  return {
    type: CLEAR_CATEGORY,
    guideId,
  };
}

export function setBrazeCategoryCards(guideId, brazeCards) {
  return {
    type: SET_BRAZE_CATEGORY_CARDS,
    meta: {
      guideId,
      brazeCards,
    },
  };
}

export function fetchBrowsies() {
  return fetchCategory({ guideId: BROWSIES_GUIDE_ID });
}

export function clearAllRecents() {
  return (dispatch) =>
    dispatch({
      type: CLEAR_ALL_RECENTS,
      api: {
        endpoint: ['user', 'deleteRecents'],
        args: [],
      },
    }).then(() => {
      dispatch(showMessage(CLEAR_ALL_RECENTS_SUCCESS_TOAST));

      // Re-fetch rather than dropping the cached category: the Recents page renders straight from
      // it, so evicting the entry would blank the very page the user is standing on. Re-fetching
      // also brings back the container's fresh `prompt`/`actions` (the empty-state copy, and no
      // more `clearAllRecents`) instead of leaving stale ones behind.
      return dispatch(fetchCategory({ guideId: RECENTS_GUIDE_ID }));
    });
}

export function removeRecent(guideId) {
  return (dispatch, getState) =>
    dispatch({
      type: REMOVE_RECENT,
      api: {
        endpoint: ['user', 'deleteRecents'],
        args: [guideId],
      },
    }).then(() => {
      dispatch(showMessage(CLEAR_SINGLE_RECENT_SUCCESS_TOAST));

      // Refresh whatever category the user is standing on, not just the Recents page: recents also
      // appear as a shelf on the home screen, and each page renders straight from its own cached
      // category entry. Re-fetching with the route's whole `guideContext` — rather than just its
      // guideId — matters because the store is keyed on guideId *and* attributes
      // (see getStoreGuideId), so dropping the attributes would refresh a different entry than the
      // one the page reads and leave the removed item on screen.
      const { guideContext } = selectRouteProps(getState()) || {};

      // TODO: Find less expensive way to refresh the home page after single recent deletion
      return dispatch(
        fetchCategory(guideContext?.guideId ? guideContext : { guideId: RECENTS_GUIDE_ID }),
      );
    });
}
